<template>
    <div class="signUpForm">
        <div class="pt-5 mx-3">
            <div class="d-flex justify-content-center align-items-center">
                <img border="0" :src="imgPath" width="120" height="120" alt="">
            </div>
            <h2 class="text-center py-3 comment-color">会員新規登録</h2>
            <p class="mb-4 text-center comment-color">
                会員情報の登録が完了しました。
            </p>
            <div class="text-center mb-4">
                <button
                    type="button"
                    class="confirmbutton col-sm-4"
                    @click="toLoginPage()"
                >{{ btnName }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            btnName: '戻る',
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png"
        };
    },
    beforeRouteLeave (to, from, next) {
        if (to.path === '/signup-form') {
            next(false);
        } else {
            next();
        }
    },
    created () {
        this.initialize();
    },
    methods: {
        async initialize () {
            if (process.env.MIX_APP_URL) {
                this.btnName = 'アプリを起動';
            } else if (!localStorage.getItem("Reserve.logInUrl")){
                this.btnName = "ログインページに戻る";
            } else {
                this.btnName = "予約ページでログインする";
            }
        },
        toLoginPage: function() {
            if (process.env.MIX_APP_URL) {
                window.location.href = process.env.MIX_APP_URL;
            } else if (!localStorage.getItem("Reserve.logInUrl")) {
                this.$router.push("/");
            } else {
                const url = localStorage.getItem("Reserve.logInUrl");
                localStorage.removeItem("Reserve.logInUrl");
                this.$router.push(url);
            }
        }
    }
};
</script>

<style scoped>
.signUpForm {
    height: 100vh;
}
</style>
